import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <div>
      <div className="container">
  <div className="row">
    <div className="col-lg-12">
      <div className="main-header-one-wrapper">
        <div className="tmp-nav-area-one header--sticky">
          {/* Logo */}
          <div className="logo-area-start">
            <Link className="logo" to="/">
              <img height="61" width="188"
                // src={require("../assets/images/logo/logo-01.png")}
                src={"/assets/images/logo/starpath-logo.svg"}
                alt="Corporate_business_logo"
              />
            
            </Link>
          </div>

          {/* Navigation Menu */}
          <div className="header-nav main-nav-one">
            <nav>
              <ul className="parent-nav">
                <li>
                  <Link className="nav-link" to="/">
                    <span >HOME</span>
                  </Link>
                  {/* <ul className="submenu mega-menu-wrapper">
                    Multipages
                    <li className="menu-single-list">
                      <Link to="#" className="top-title">Multipages</Link>
                      <ul>
                        <li><Link to="/corporate">Corporate Demo</Link></li>
                        <li><Link to="/financial">Financial Demo</Link></li>
                        <li><Link to="/marketing">Marketing Demo</Link></li>
                        <li><Link to="/agency">Agency Demo</Link></li>
                        <li><Link to="/startup">Startup Demo</Link></li>
                        <li><Link to="/construction">Construction Demo</Link></li>
                        <li><Link to="/construction-two">Construction 2 Demo</Link></li>
                        <li><Link to="/company">Company Demo</Link></li>
                      </ul>
                    </li>
                    Onepages
                    <li className="menu-single-list">
                      <Link to="#" className="top-title">Onepages</Link>
                      <ul>
                        <li><Link to="/onepage/corporate">Onepage Corporate</Link></li>
                        <li><Link to="/onepage/financial">Onepage Financial</Link></li>
                        <li><Link to="/onepage/marketing">Onepage Marketing</Link></li>
                        <li><Link to="/onepage/agency">Onepage Agency</Link></li>
                        <li><Link to="/onepage/startup">Onepage Startup</Link></li>
                        <li><Link to="/onepage/construction">Onepage Construction</Link></li>
                        <li><Link to="/onepage/construction-two">Onepage Construction 2</Link></li>
                        <li><Link to="/onepage/company">Onepage Company</Link></li>
                      </ul>
                    </li>
                  </ul> */}
                </li>
              {/* 
                <li>
                  <Link className="nav-link" to="/about">
                    <span className="rolling-text">ABOUT</span>
                  </Link>
                </li> */}

                <li className="has-dropdown">
                  <Link className="nav-link" to="#">
                    {/* <span className="rolling-text">SERVICES</span> */}
                    <span >SERVICES</span>
                  </Link>
                  <ul className="submenu">
                    <li><Link to="/agency">Infra Service Provider</Link></li>
                    <li><Link to="/itconsulting">IT Consulting</Link></li>
                    <li><Link to="/marketing">Digital Marketing</Link></li>
                    <li><Link to="/financial">Financial Consulting</Link></li>
                  </ul>
                </li>
{/* 
                <li className="has-dropdown">
                  <Link className="nav-link" to="#">
                    <span className="rolling-text">BLOG</span>
                  </Link>
                  <ul className="submenu">
                    <li><Link to="/blog">Blog</Link></li>
                    <li><Link to="/blog/col-1">Blog Col 1</Link></li>
                    <li><Link to="/blog/col-2">Blog Col 2</Link></li>
                    <li><Link to="/blog/details">Blog Details</Link></li>
                    <li><Link to="/project/details-v2">Blog Details v2</Link></li>
                  </ul>
                </li> */}

                {/* <li className="has-dropdown">
                  <Link className="nav-link" to="#">
                    <span className="rolling-text">PAGES</span>
                  </Link>
                  <ul className="submenu">
                    <li><Link to="/appointment">Appointment</Link></li>
                    <li><Link to="/project">Project</Link></li>
                    <li><Link to="/project/mesonary">Project Mesonary</Link></li>
                    <li><Link to="/project/mesonary-v2">Project Mesonary v2</Link></li>
                    <li><Link to="/project/slider">Project Slider</Link></li>
                    <li><Link to="/project/details">Project Details</Link></li>
                    <li><Link to="/project/details-v2">Project Details v2</Link></li>
                    <li><Link to="/team">Team</Link></li>
                    <li><Link to="/team-2">Team Two</Link></li>
                    <li><Link to="/team-details">Team Details</Link></li>
                    <li><Link to="/pricing">Pricing</Link></li>
                    <li><Link to="/faq">FAQ</Link></li>
                  </ul>
                </li> */}

                <li>
                  <Link className="nav-link" to="/training-internship">
                    <span>TRAINING &amp; INTERNSHIP</span>
                  </Link>
                </li>

                <li>
                  <Link className="nav-link" to="/contact">
                    {/* <span className="rolling-text">CONTACT</span> */}
                    <span >CONTACT</span>
                  </Link>
                </li>
              </ul>
            </nav>
          </div>

          {/* Mobile Menu Toggle Icon */}
          <div className="actions-area">
            <div className="tmp-side-collups-area" id="side-collups">
              <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="14" width="20" height="2" fill="#1F1F25"></rect>
                <rect y="7" width="20" height="2" fill="#1F1F25"></rect>
                <rect width="20" height="2" fill="#1F1F25"></rect>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default Navbar